import { Box } from '@chakra-ui/react';
import Script from 'next/script';
import parse from 'html-react-parser';
import React, { useEffect } from 'react';

const Tweet: React.FC<{ id: string }> = ({ id }) => {
  useEffect(() => {
    // twttrはTwitterのウィジェットライブラリによってグローバルに追加されるオブジェクトだが、型定義が存在しないためエラー抑制
    // @ts-expect-error
    window.twttr?.widgets.load();
  }, [id]);

  return (
    <>
      {parse(
        `<blockquote class="twitter-tweet"><a href="https://twitter.com/i/status/${id}"></a></blockquote>`,
      )}
    </>
  );
};

export function XPostWidget({ xPostId }: { xPostId: string }) {
  return (
    <Box fontSize="sm" h="fit-content" w="100%" my={-2.5}>
      <Tweet id={xPostId} />
      <Script
        src="https://platform.twitter.com/widgets.js"
        strategy="lazyOnload"
      />
    </Box>
  );
}
